export const style = {
    navItem: (isActive) => {
        const defaultStyle = {
            height: '60px',
            borderBottom: '1px solid #b4b2b1',
            display: 'flex',
            fontSize: 3,
            lineHeight: '24px',
            textDecoration: 'none',
            padding: 4,
            color: 'neutral.1000',
            gap: 3,
            alignItems: 'center'
        };
        if (isActive) {
            return {
                ...defaultStyle,
                color: 'primary.800',
                '&:visited': {
                    color: 'pirmary.800'
                },
                fontWeight: 'bold'
            };
        }
        else {
            return {
                ...defaultStyle,
                '&:visited': {
                    color: 'neutral.1000'
                }
            };
        }
    },
    main: (isShow) => {
        return { visibility: isShow ? 'visible' : 'hidden' };
    },
    navItemContent: {
        flex: 1
    },
    topBar: {
        padding: 'sc3',
        textAlign: 'right',
        height: '3.75rem'
    },
    wrapper: {
        width: '100vw',
        height: '100vh'
    }
};
